import React from 'react'
import UnregisteredMainContent from './UnregisteredMainContent/UnregisteredMainContent'
import classes from './UnregisteredHome.module.scss'

const UnregisteredHome = () => {


    return (
        <div className={classes.projectContainer}>
                <UnregisteredMainContent/>
        </div>
    )
}

export default UnregisteredHome
